"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "YearGeneralHandler", {
    enumerable: true,
    get: function() {
        return YearGeneralHandler;
    }
});
const _catchError = require("src/helpers/catchError");
const _numbergeneralhandler = require("../number/number.general.handler");
let YearGeneralHandler = class YearGeneralHandler extends _numbergeneralhandler.NumberGeneralHandler {
    async parseUserInput(params) {
        var _this;
        const value = (_this = await super.parseUserInput(params)) == null ? void 0 : _this.value;
        if (typeof value === 'number') {
            if (value < 1000 || value > 9999) {
                _catchError.NcError.invalidValueForField({
                    value: value.toString(),
                    column: params.column.title,
                    type: params.column.uidt
                });
            }
        }
        return {
            value
        };
    }
};
